export function hasImageShopify(src) {
  // Return true, false
  if (!src) {
    return false;
  }
  const arrayPath = ['cdn.shopify.com/s/files/', 'apps.shopifycdn.com/', '/cdn/shop/'];
  return arrayPath.some((path) => src.includes(path));
};

export function replaceImageToSize(src, expectImageSize) {
  if (!src || expectImageSize == undefined || expectImageSize == null) {
    return src;
  }
  if (hasImageShopify(src)) {
    var ignore = ["jfif"]
    var params = "";
    var splitParams = src.split("?");
    if (splitParams && splitParams.length && splitParams.length >= 2) {
      params = splitParams[1]
    }
    var arrImage = splitParams[0].split("/").pop();
    var slugName = arrImage.split(".");
    var strExtention = slugName.pop();
    if (ignore.indexOf(strExtention) !== -1) {
      return src;
    }
    var nameImages = slugName.join(".");
    var arrayNames = nameImages.split("_");
    if (arrayNames && arrayNames.length >= 2) {
      var sizeCurrent = arrayNames.pop();
      var reg = new RegExp(/(\d+)x(\d+)|(\d+)x|x(\d+)/, "gm")
      if (sizeCurrent && reg.test(sizeCurrent)) {
        var trimReg = sizeCurrent.replace(reg, "");
        if (trimReg == "") {
          nameImages = nameImages.split("_");
          nameImages.pop();
          nameImages = nameImages.join("_");
        }
      }
    }
    var srcImageSplit = src.split("?")[0].split("/");
    var smallSrc = "";
    for (var j = 0; j < srcImageSplit.length - 1; j++) {
      smallSrc += srcImageSplit[j] + "/";
    }
    if (expectImageSize) {
      src = smallSrc + nameImages + "_" + expectImageSize + "." + strExtention;
    } else {
      src = smallSrc + nameImages + "." + strExtention;
    }
    if (params) {
      src = src + "?" + params;
    }
  }
  return src;
}
